import React from 'react';

import { Progress } from '@buildoutinc/blueprint-react/ui/Progress';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import ImageDropzone from 'components/image_dropzone';
import { Button } from 'components/ui/button';

interface Props {
  allowUpload?: () => boolean,
  label?: string,
  onUpload: (data: { id: number, url: string, file_type?: string }) => void
}

export default function UploadButton({ allowUpload, label = 'Add', onUpload }: Props) {
  return (
    <ImageDropzone
      allowUpload={allowUpload}
      dropBox={<Button icon={faPlus} label={label} variant="ghost" />}
      noKeyboard
      UniqueProgressBar={UploadProgress}
      onUploadComplete={onUpload}
    />
  );
}

function UploadProgress({ now }: { now: number }) {
  return <Progress label="Uploading" showPercentage value={now} />;
}
